import { defineComponent as a, createElementBlock as s, openBlock as m, mergeProps as d, unref as o, renderSlot as p } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DescriptionList/description-list.js";
import { c_description_list_GridTemplateColumns_min as u } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_description_list_GridTemplateColumns_min.js";
import { c_description_list__term_width as f } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_description_list__term_width.js";
import { c_description_list_m_horizontal__term_width as h } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_description_list_m_horizontal__term_width.js";
import { useOUIAProps as c } from "../../helpers/ouia.js";
import { cssVarsFromBreakpointProps as n, classesFromBreakpointProps as y } from "../../breakpoints.js";
const L = /* @__PURE__ */ a({
  name: "PfDescriptionList",
  __name: "DescriptionList",
  props: {
    autoFit: { type: Boolean },
    horizontal: { type: Boolean },
    autoColumnWidths: { type: Boolean },
    inlineGrid: { type: Boolean },
    compact: { type: Boolean },
    fluid: { type: Boolean },
    fillColumns: { type: Boolean },
    displaySize: { default: "default" },
    termWidth: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    columns: {},
    columnsSm: {},
    columnsMd: {},
    columnsLg: {},
    columnsXl: {},
    columns2xl: {},
    orientation: {},
    orientationSm: {},
    orientationMd: {},
    orientationLg: {},
    orientationXl: {},
    orientation2xl: {},
    autoFitMin: {},
    autoFitMinSm: {},
    autoFitMinMd: {},
    autoFitMinLg: {},
    autoFitMinXl: {},
    autoFitMin2xl: {},
    horizontalTermWidth: {},
    horizontalTermWidthSm: {},
    horizontalTermWidthMd: {},
    horizontalTermWidthLg: {},
    horizontalTermWidthXl: {},
    horizontalTermWidth2xl: {}
  },
  setup(r) {
    const e = r, l = c({ id: e.ouiaId, safe: e.ouiaSafe });
    return (i, z) => (m(), s("dl", d(o(l), {
      class: [
        o(t).descriptionList,
        o(y)(i.$props, ["columns", "orientation"], o(t), { short: !0 }),
        {
          [o(t).modifiers.horizontal]: i.horizontal || i.fluid,
          [o(t).modifiers.autoColumnWidths]: i.autoColumnWidths,
          [o(t).modifiers.autoFit]: i.autoFit,
          [o(t).modifiers.inlineGrid]: i.inlineGrid,
          [o(t).modifiers.compact]: i.compact,
          [o(t).modifiers.fluid]: i.fluid,
          [o(t).modifiers.fillColumns]: i.fillColumns,
          [o(t).modifiers.displayLg]: i.displaySize === "lg",
          [o(t).modifiers.display_2xl]: i.displaySize === "2xl"
        }
      ],
      style: {
        [o(f).name]: i.termWidth,
        ...o(n)(e, "autoFitMin", o(u).name),
        ...o(n)(e, "horizontalTermWidth", o(h).name)
      }
    }), [
      p(i.$slots, "default")
    ], 16));
  }
});
export {
  L as default
};
